module.exports = __webpack_public_path__ + "images/ansvar_smallc977dc112ee31321e911fb230fed47c8.png";